/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PutChainBulkBillingExcludedPharmaciesRequestBodyTypename =
  "PutChainBulkBillingExcludedPharmaciesRequestBody" as const;

/**
 *
 * @export
 * @interface PutChainBulkBillingExcludedPharmaciesRequestBody
 */
export interface PutChainBulkBillingExcludedPharmaciesRequestBody {
  /**
   *
   * @type {Array<number>}
   * @memberof PutChainBulkBillingExcludedPharmaciesRequestBody
   */
  pharmacyIds: Array<number>;
  /**
   * Resource type name
   * @type {string}
   * @memberof PutChainBulkBillingExcludedPharmaciesRequestBody
   */
  readonly __typename?: string;
}

export function PutChainBulkBillingExcludedPharmaciesRequestBodyFromJSON(
  json: any
): PutChainBulkBillingExcludedPharmaciesRequestBody {
  return PutChainBulkBillingExcludedPharmaciesRequestBodyFromJSONTyped(json, false);
}

export function PutChainBulkBillingExcludedPharmaciesRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PutChainBulkBillingExcludedPharmaciesRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PutChainBulkBillingExcludedPharmaciesRequestBodyTypename,

    pharmacyIds: json["pharmacy_ids"],
  };
}

export function PutChainBulkBillingExcludedPharmaciesRequestBodyToJSON(
  object?: PutChainBulkBillingExcludedPharmaciesRequestBody | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    pharmacy_ids: value.pharmacyIds,
  };
}
